export const french = {
    fr: {
        translation: {
            'home': 'Accueil',
            'edit-article': 'Edition d\'un article',
            'tutorial': 'Tutoriel',
            articles: {
                'empty': 'Aucun article'
            },
            button: {
                download: 'Télécharger',
                'consult': 'Consulter'
            },
            card: {
                publishedAt: 'Publié le'
            },
            search: {
                placeholder: 'Rechercher'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/config/translation/fr/index.js